class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
        
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

 shipping_est()
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

function shipping_est() {
  $.ajax({
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      let cart_dt = data;
      if(data) {
        var obj = data.items;
        var gtot = 0;
        $.each(obj, function(key, value) {
          gtot = (value.grams * value.quantity) + gtot;
        });
        var weight = Math.round(gtot / 453.6),
            percentage = Math.round(((Math.round(gtot / 453.6)) / 1200) * 100),
            modulo = ((weight % 250) - 250) * -1,
            pt = percentage + "%";
        console.log(pt);

        // Set progress bar width and background color based on weight
        $('.progress-value').each(function() {
          $(this).removeClass('animated').css('width', pt);
          if (weight > 1200) {
            $(this).css('background-color', '#007D48 !important'); // Set the background color to #007D48 when weight > 1200
          } else {
            $(this).css('background-color', ''); // Reset background color otherwise
          }
        });

        $('.addmore .weight').each(function() {
          $(this).text(modulo);
        });
      }

      // Existing estimator code...
      if ($('.shipping-estimates .totals-est').length > 0) {
        $.ajax({
          type: "POST",
          url: '//hook.us1.make.celonis.com/b10fd8ltisl5fzxo7728u6tst301how6',
          data: data,
          dataType: 'json',
          success: function(data) {
            const { service_name, max_delivery_date, min_delivery_date, total_price } = data.rates[0];
            var mny = data.rates[0].total_price,
                mnytot = data.rates[0].original_price;
            $('.shipping-estimates .totals-est').text("$" + parseInt(mny) / 100);
            $('.shipping-estimates2 .totals-est').text("$" + parseInt(mny) / 100);
            $('.shipping-estimates .totals-esttot').text(mnytot);
            $('.shipping-estimates2 .totals-esttot').text(mnytot);

            // Additional logic for calculating savings
            var total_est_saving = $('.total-est-saving');
            var final_est_price = $('.total_discount_est_final');
            var total_crt_org_pr = cart_dt.original_total_price;
            var total_crt_pr = cart_dt.total_price;
            if (total_est_saving.length) {
              var shipping_discount_pr = parseFloat(data.rates[0].total_price);
              var shipping_total_string = data.rates[0].original_price;
              var shipping_total_pr = parseInt(shipping_total_string.replace(/[^\d]/g, ''));
              var total_est_save = 0;
              if (total_crt_org_pr > total_crt_pr && total_crt_pr != 0) {
                var save_on_item = total_crt_org_pr - total_crt_pr;
                total_est_save += save_on_item;
              }

              if (shipping_total_pr > shipping_discount_pr && shipping_discount_pr != 0) {
                var shiping_est_save = shipping_total_pr - shipping_discount_pr;
                total_est_save += shiping_est_save;
              }

              if (total_est_save > 0) {
                var savedAmount = '$' + (total_est_save / 100);
                total_est_saving.find('span').text(savedAmount);
              }
            }
            if (final_est_price) {
              var total_est_is = (total_crt_pr / 100) + (mny / 100);
              final_est_price.text('$' + total_est_is.toFixed(2));
            }
          }
        });
      }
    }
  });
}
shipping_est();